<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div style="margin: 0px 20px;">
              <div v-if="list === true">
                <div class="float-left">
                  <strong style="color: #000A2C; text-align: left; margin: 20px;" class="class-teach-name">Teaching Subjects</strong>
                </div>
                <div class="float-right">
                  <strong class="custom-text-viewall" style="margin: 20px;" @click="AddNewSubject()">Add Subject</strong>
                </div>
                <div style="clear: both"></div>
                <br />
                <div v-for="item in teacherSub" v-bind:key="item.Id">
                  <CCard  style="margin-bottom: 10px;">
                    <div class="mt-2 mb-2">                   
                      <CRow style="margin-right: 0px; margin-left: 0px;">
                        <div style="width: 70%" class="float-left">
                          <label class="text-primary-custom ml-2 mb-0 text-left" style="color: #000A2C; font-size:12px;">{{item.subjectName}}</label>                  
                          <label class="custom-user-subtitle ml-2" style="color: #000A2C;">{{item.gradeName}}</label>
                        </div>
                        <div style="width: 30%" class="float-right">
                          <CRow class="float-right mr-4 mt-3">
                            <img src="../../assets/img/icon/trash.svg" style="-webkit-filter:invert(32%) sepia(75%) saturate(4835%) hue-rotate(8deg) brightness(98%) contrast(101%); filter: invert(32%) sepia(75%) saturate(4835%) hue-rotate(8deg) brightness(98%) contrast(101%);" @click="DeleteSubjectPopup(item.teachingGradeId)" />
                          </CRow>
                        </div>
                      </CRow>
                    </div>
                  </CCard>
                </div>
              </div>
            </div>
            
            <div v-if="addnew === true">
              <h4 style="color: #000; text-align: left" class="custom-user-name">
                Select subject you want to focus on
              </h4>
              <div class="ml-3 mr-3">
                <v-select
                  horizontal
                  v-model="subjectSelected"
                  :options="subject"
                  label="subjectName"
                  placeholder="Select Subject"
                />
              </div>

              <br />

              <h4 style="color: #000; text-align: left" class="custom-user-name">
                Select grade
              </h4>
              <div class="ml-3 mr-3">
                <v-select
                  horizontal
                  v-model="gradeSelected"
                  :options="grade"
                  label="gradeName"
                  placeholder="Select Grade"
                />
              </div>

              <div class="bottom-center">
                <CButton class="btn-select-blue mt-5" @click="SubmitAddNew(subjectSelected, gradeSelected)">Add Subject</CButton>
              </div>

            </div>
            
          </div>
        </div>
      </div>
    </CContainer>

    <CModal size="md" :show.sync="ConfirmDelete">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">
          Confirm Delete
        </h3>
        <br />
      </div>
      <div class="text-center">
        <h4 class="sub-title-header" style="color: #000a2c">
          Are you sure to delete selected subject ?
        </h4>
        <br />
      </div>
      <!-- <div class="text-center">
        <CButton class="btn-select-blue mt-5">No, I Change My Mind</CButton>
      </div> -->
      <div class="text-center">
        <CButton class="btn-select-blue mt-2" @click="DeleteSubject(teachgradeId)">
          Yes, I'm sure
        </CButton>
      </div>
    </CModal>
    
    <div class="header-top">Change Grade</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);

export default {
  data: function () {
    return {
      teacher: {},
      teacherSub: [],
      subject: [],
      grade: [],

      subjectSelected: "",
      gradeSelected: "",
      subjectSelectedId: "",
      gradeSelectedId: "",
      teachgradeId: "",

      // FilterGrade: [],
      // SelectedGrade: '',
      list: true,
      addnew: false,
      ConfirmDelete: false,
    };
  },

  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetTeacherProfile(this.user.id);
            this.GetTeacherSubjectGrade(this.user.id);
            this.GetSubjectList();
            this.GetGradeList();
          }
        });
    },

    GetTeacherProfile() {
    this.$API
      .get(this.$TeacherProfile + "?userId=" + this.user.id, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.teacher = response.data;
          this.photoURL = this.teacher;
            console.log("teacher", this.teacher);
        }
      });
    },

    GetTeacherSubjectGrade() {
    this.$API
      .get(this.$TeacherSubjectGrade + "?userId=" + this.user.id, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.teacherSub = response.data;
          // this.photoURL = this.teacher;
            // console.log("teacher", this.teacher);
        }
      });
    },

    GetSubjectList() {
    this.$API
      .get(this.$SubjectListAuthorize, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.subject = response.data;
          console.log("subject",this.subject);
        }
      });
    },

    GetGradeList() {
      this.$API
        .get(this.$GradeListAuthorize, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grade = response.data;
          }
        });
    },

    SubmitAddNew(subjectSelected, gradeSelected) {
      // this.list = true;
      for (let index = 0; index < this.subject.length; index++) {
        var sub = this.subject[index];
        console.log("testsub", sub);

        if (sub.subjectName == subjectSelected.subjectName)
        {
          var subId = sub.id;
          this.subjectSelectedId = subId;
          console.log("testSubjectId", this.subjectSelectedId);

          for (let i = 0; i < this.grade.length; i++) {
            var gra = this.grade[i];

            if (gra.gradeName == gradeSelected.gradeName)
            {
              var graId = gra.id;
              this.gradeSelectedId = graId;
              console.log("testGradeId", this.gradeSelectedId);

              const formData = new FormData();

              formData.append("TeachingGradeId", this.gradeSelectedId);
              formData.append("ContentGrade", gradeSelected.gradeName);
              formData.append("TeacherId", this.teacher.teacherId);
              formData.append("TeachingSubjectId", this.subjectSelectedId);
              formData.append("Content", subjectSelected.subjectName);

              return this.$API
                .post(this.$TeacherAddNewSubject, formData, {
                  withCredentials: true,
                })
                .then((response) => {
                  if (response.status == 200) {
                    this.Busy = false;
                    this.$dialog.alert("Success add").then(function () {});
                    this.GetTeacherSubjectGrade(this.user.id);
                    this.list = true;
                    this.addnew = false;
                  } else {
                    this.Busy = false;
                    this.$dialog.alert("Error to add").then(function () {});
                  }
                })
                .catch((error) => {
                  this.Busy = false;
                  this.Loading = false;
                  this.Error = true;
                  this.Message = error.response.data.message;
                });

            }
          }
        }

        
      }
      
    },

    DeleteSubjectPopup(teachingGradeId) {
      this.teachgradeId = teachingGradeId;
      this.ConfirmDelete = true;
    },

    DeleteSubject: function(teachingGradeId) {
      const formData = new FormData();

      formData.append("id", teachingGradeId);

      return this.$API
        .post(this.$DeleteTeacherSubjectGrade, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success deleted").then(function () {});
            this.GetTeacherSubjectGrade(this.user.id);
            this.ConfirmDelete = false;
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to add").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    GoBack() {
      this.$router.back();
    },
    
    

    AddNewSubject() {
      this.list = false;
      this.addnew = true;
    }
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="radio"] {
  opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
</style>